/**
 * Tracing Configuration
 *
 * Configuration for distributed tracing across GraphQL queries and API calls.
 * Implements sampling to control cost and overhead while maintaining observability.
 */

import { targetEnvironment } from '../../configs/environments';

/**
 * Default sampling rate for traces.
 * 1% = 0.01 means we sample 1 out of every 100 requests.
 * This helps control cost while still providing meaningful data for debugging and monitoring.
 */
export const DEFAULT_SAMPLING_RATE = 0.01;

/**
 * Tracing feature flag
 * Set to false to disable all tracing (useful for testing or debugging)
 */
export const TRACING_ENABLED = true;

/**
 * Environment-specific sampling rates
 * Can be adjusted based on environment needs
 */
export const SAMPLING_RATES: Record<string, number> = {
  production: 0.01, // 1% in production
  staging: 0.05, // 5% in staging for more visibility
  development: 0.1, // 10% in development
  mock: 0, // No tracing in mock environment
  local: 0.1, // 10% in local development
};

/**
 * Get the current sampling rate based on environment
 */
export function getSamplingRate(): number {
  return SAMPLING_RATES[targetEnvironment] ?? DEFAULT_SAMPLING_RATE;
}
